import css from 'styled-jsx/css';
import {
  colorHighlight,
  colorPalette,
  sansSerif,
  serif
} from 'styles/css-constants';

export default css`
  .Product--in-post {
    display: flex;
    flex-direction: column;
    text-decoration: none;
  }

  .Product--in-post .Product__cta,
  .Product--in-post .Product__price,
  .Product--in-post .Product__retailer {
    font-family: ${sansSerif};
  }

  .Product--in-post .Product__cta {
    -webkit-appearance: none;
    -moz-appearance: none;
    display: inline-block;
    padding: 0.375rem 0.5rem;
    border: 1px solid ${colorHighlight};
    color: ${colorHighlight};
    font-size: var(--fontScaleNeg1);
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  .Product--in-post .Product__image {
    margin-bottom: 1rem;
  }

  .Product--in-post .Product__name {
    margin-bottom: 0.5rem;
    color: #000;
    font-family: ${serif};
    font-size: var(--fontScale2);
    font-weight: 700;
  }

  .Product--in-post .Product__price {
    margin-bottom: 0.25rem;
    color: #000;
    font-size: var(--fontScale1);
  }

  .Product--in-post .Product__original-price {
    margin-right: 0.5rem;
    display: inline-block;
    color: ${colorPalette.gray};
    text-decoration: line-through;
  }

  .Product--in-post .Product__retailer {
    margin-bottom: 1rem;
    color: ${colorPalette.gray};
    font-size: var(--fontScaleNeg2);
    text-transform: uppercase;
  }

  .Product--in-post .Product__description {
    color: #000;
    margin-bottom: 1rem;
  }

  .Product--in-post .Product__description :global(a) {
    border-bottom: 1px solid ${colorHighlight};
    color: #000;
  }

  @media (min-width: 48rem) {
    .Product--in-post {
      flex-direction: row;
    }

    .Product--in-post .Product__body {
      flex: 0 0 50%;
      padding-left: 1rem;
    }

    .Product--in-post .Product__cta {
      padding: 0.5rem 1.25rem;
      font-size: var(--baseFontSize);
    }

    .Product--in-post .Product__image {
      flex: 0 0 50%;
      margin-bottom: 0;
    }

    .Product--in-post .Product__price {
      font-size: var(--fontScale1);
    }

    .Product--in-post .Product__retailer {
      font-size: var(--fontScaleNeg1);
    }
  }
`;
